<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3">
<h1 class="tochead">CONTENTS</h1>
</a><h2 class="toc_front"><a id="page_3"></a><a href="#/xhtml/04_Introduction">Introduction</a></h2>
<h2 class="toc_front"><a href="#/xhtml/05_Timeline">Timeline</a></h2>
<h2 class="toc_front"><a href="#/xhtml/06_Notable_battleships">Notable Battleships and Battlecruisers</a></h2>
<h2 class="toc_chap1"><a href="#/xhtml/07_Chapter_01"><span class="toc_hang1">Chapter 1:</span> Pre-dreadnought Era</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/08_Chapter_02" title="Link target outside of Sample"><span class="toc_hang">Chapter 2:</span> <em class="italic">Dreadnought</em> and the Anglo-German Naval Arms Race</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/09_Chapter_03" title="Link target outside of Sample"><span class="toc_hang">Chapter 3:</span> World War I</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_04" title="Link target outside of Sample"><span class="toc_hang">Chapter 4:</span> Interwar Period</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_05" title="Link target outside of Sample"><span class="toc_hang">Chapter 5:</span> World War II</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_06" title="Link target outside of Sample"><span class="toc_hang">Chapter 6:</span> Battleships in the Cold War</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_07" title="Link target outside of Sample"><span class="toc_hang">Chapter 7:</span> Comeback of the Battleship and the End of an Era</span></h2>
<h2 class="toc_back1"><span href="#/xhtml/14_Bibliography" title="Link target outside of Sample">Select Bibliography</span></h2>
<h2 class="toc_back"><span href="#/xhtml/15_Acknowledgement" title="Link target outside of Sample">Acknowledgements</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?bf3f90ca